<template>
  <div class="CartProducts3">
    <div class="cart-products">
      <section id="servicios" class="secciones seccion-gris">
        <div id="etapas-compra">
          <div class="etapas-compra-hitos">
            <router-link :to="'/carrito'" class="hito-inactivo">Carro de compras</router-link>
            <router-link :to="'/datos-compra'" class="hito-activo">Datos para la compra</router-link>
            <a class="hito-inactivo" disabled>Finalizar Compra</a>
          </div>
        </div>

        <!-- Modal Agregar -->
        <div
          class="modal fade"
          id="nuevadireccion"
          tabindex="-1"
          role="dialog"
          aria-labelledby="domicilio"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-body text-center modal-contenido">
                <button type="button" class="btn-close-modern" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>

                <div class="container">
                  <div class="col-sm-12">
                    <h4><strong>Agregar nueva dirección de despacho</strong></h4>
                    <br />
                    <br />
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-4 form-col">
                                <label class="control-label" for="lastName">Departamento *: </label>
                              </div>
                              <div class="col-sm-8">
                                <select
                                  v-model="cboDepartamento_modal"
                                  id="basicSelect"
                                  :plain="true"
                                  @change="(event) => callProvincias(cboDepartamento_modal, false)"
                                  class="form-control"
                                  required
                                >
                                  <option disabled value="">Seleccione Departamento</option>
                                  <option
                                    v-for="depa in depas_array"
                                    :key="depa.id_departament"
                                    :value="depa.id_departament"
                                    >{{ depa.desc_departament }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-4 form-col">
                                <label class="control-label" for="lastName">Provincia *: </label>
                              </div>
                              <div class="col-sm-8">
                                <select
                                  v-model="cboProvincia_modal"
                                  id="basicSelect"
                                  :disabled="isdisabled"
                                  required
                                  :plain="true"
                                  @change="(event) => callDistritos(cboProvincia_modal, false)"
                                  class="form-control"
                                >
                                  <option disabled value="">Seleccione Provincia</option>
                                  <option
                                    v-for="provincia in province_array"
                                    :key="provincia.id_province"
                                    :value="provincia.id_province"
                                    >{{ provincia.desc_province }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-4 form-col">
                                <label class="control-label" for="lastName">Distrito *: </label>
                              </div>
                              <div class="col-sm-8">
                                <select
                                  v-model="cboDistrito_modal"
                                  id="basicSelect"
                                  :disabled="isdisabled_distrito"
                                  required
                                  :plain="true"
                                  @change="(event) => enableDireccion()"
                                  class="form-control"
                                >
                                  <option disabled value="">Seleccione Distrito</option>
                                  <option
                                    v-for="distrito in distrito_array"
                                    :key="distrito.id_district"
                                    :value="distrito.id_district"
                                    >{{ distrito.desc_district }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-4 form-col">
                                <label class="control-label" for="lastName"
                                  >Dirección de despacho *:
                                </label>
                              </div>
                              <div class="col-sm-8">
                                <textarea
                                  type="text"
                                  class="form-control"
                                  v-model="client_address_modal"
                                  id="emailId"
                                  placeholder="Dirección"
                                  minlength="10"
                                  maxlength="255"
                                  required
                                  :disabled="isdisabled_direccion"
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="agregar_direccion()"
                    data-dismiss="modal"
                  >
                    Agregar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Modificar -->
        <div
          class="modal fade"
          id="modificardireccion"
          tabindex="-1"
          role="dialog"
          aria-labelledby="domicilio"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-body text-center modal-contenido">
                <button type="button" class="btn-close-modern" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>

                <div class="container">
                  <div class="col-sm-12">
                    <h4><strong>Actualizar dirección de despacho</strong></h4>
                    <br />
                    <br />
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-4 form-col">
                                <label class="control-label" for="lastName">Departamento *: </label>
                              </div>
                              <div class="col-sm-8">
                                <select
                                  v-model="cboDepartamento_modal"
                                  id="basicSelect"
                                  :plain="true"
                                  @change="(event) => callProvincias(cboDepartamento_modal, false)"
                                  class="form-control"
                                  required
                                >
                                  <option disabled value="">Seleccione Departamento</option>
                                  <option
                                    v-for="depa in depas_array"
                                    :key="depa.id_departament"
                                    :value="depa.id_departament"
                                    >{{ depa.desc_departament }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-4 form-col">
                                <label class="control-label" for="lastName">Provincia *: </label>
                              </div>
                              <div class="col-sm-8">
                                <select
                                  v-model="cboProvincia_modal"
                                  id="basicSelect"
                                  :disabled="isdisabled"
                                  required
                                  :plain="true"
                                  @change="(event) => callDistritos(cboProvincia_modal, false)"
                                  class="form-control"
                                >
                                  <option disabled value="">Seleccione Provincia</option>
                                  <option
                                    v-for="provincia in province_array"
                                    :key="provincia.id_province"
                                    :value="provincia.id_province"
                                    >{{ provincia.desc_province }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-4 form-col">
                                <label class="control-label" for="lastName">Distrito *: </label>
                              </div>
                              <div class="col-sm-8">
                                <select
                                  v-model="cboDistrito_modal"
                                  id="basicSelect"
                                  :disabled="isdisabled_distrito"
                                  required
                                  :plain="true"
                                  @change="(event) => enableDireccion()"
                                  class="form-control"
                                >
                                  <option disabled value="">Seleccione Distrito</option>
                                  <option
                                    v-for="distrito in distrito_array"
                                    :key="distrito.id_district"
                                    :value="distrito.id_district"
                                    >{{ distrito.desc_district }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-4 form-col">
                                <label class="control-label" for="lastName"
                                  >Dirección de despacho *:
                                </label>
                              </div>
                              <div class="col-sm-8">
                                <textarea
                                  type="text"
                                  class="form-control"
                                  v-model="client_address_modal"
                                  id="emailId"
                                  placeholder="Dirección"
                                  minlength="10"
                                  maxlength="255"
                                  required
                                  :disabled="isdisabled_direccion"
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="modificar_direccion()"
                    data-dismiss="modal"
                  >
                    Actualizar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Retiro en tienda -->
        <div
          class="modal fade"
          id="retiro"
          tabindex="-1"
          role="dialog"
          aria-labelledby="retiro"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-body text-center modal-contenido">
                <button type="button" class="btn-close-modern" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>

                <!--  <template v-if='updateClientData'> -->
                <h3>Zonas de retiro en tienda</h3>
                <p>Seleccione su tienda mas cercana para verificar su disponibilidad.</p>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead class="thead-gris">
                          <tr>
                            <th scope="col">Tienda y ubicación</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in despachos_recojo" :key="item.id_delivery">
                            <td
                              :style="
                                lugar_entrega == item.delivery_place
                                  ? 'background-color: cadetblue;'
                                  : ''
                              "
                            >
                              <span v-html="item.delivery_place"> </span>
                            </td>
                            <td>
                              <a
                                href="#"
                                @click="
                                  seleccionar_entrega(
                                    item.id_delivery,
                                    'Retiro en tienda',
                                    item.delivery_place,
                                    item.delivery_cost,
                                    item.delivery_date,
                                    item.delivery_schedule,
                                  )
                                "
                                ><small>Seleccionar</small></a
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="row" style="text-align: left;">
                      <div class="col-sm-12" v-if="dia_entrega != ''">
                        <h5><i class="fa fa-archive"></i> Fecha Estimada:</h5>
                        <p style="text-align: left;">
                          Puedes retirar tu pedido a partir del {{ dia_entrega | esDate }}
                        </p>
                      </div>
                      <div class="col-sm-12" v-if="dia_entrega != ''">
                        <h5><i class="fa fa-calendar-times-o"></i> Hora de Atención en tienda:</h5>
                        <p style="text-align: left;"><span v-html="horario"></span></p>
                      </div>
                      <div class="col-sm-12">
                        <h5><i class="fa fa-usd"></i> Costo del servicio:</h5>
                        <p style="text-align: left;">Gratuito</p>
                      </div>
                      <div class="col-sm-12">
                        <h5><i class="fa fa-envelope-o"></i> Notificación:</h5>
                        <p style="text-align: left;">
                          Te enviaremos un correo electrónico cuando el producto este listo para ser
                          despachado.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!--   
                          </template>
                          <template v-else>
                             <h3>Advertencia</h3>
                              <p>Debe Actualizar sus datos para continuar.</p>
                          </template>   
                           -->

                <div class="text-center">
                  <button type="button" class="btn btn-primary" data-dismiss="modal">
                    Seleccionar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Despacho a Domicilio -->
        <div
          class="modal fade"
          id="domicilio"
          tabindex="-1"
          role="dialog"
          aria-labelledby="domicilio"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-body text-center modal-contenido">
                <button type="button" class="btn-close-modern" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>

                <template v-if="selected_address != ''">
                  <!--    <template v-if='updateClientData && selected_address!=""'> -->
                  <h3>Despacho a domicilio programado</h3>
                  <p>Elija el día de su preferencia.</p>

                  <div class="lugar-hora-precio table-responsive">
                    <table class="table table-bordered">
                      <thead class="thead-gris">
                        <tr>
                          <th scope="col">
                            <small><strong>Horario</strong></small>
                          </th>
                          <template v-if="loadingUbigeo"
                            ><th scope="col">Cargando ubicación...</th></template
                          >
                          <template v-else
                            ><th
                              scope="col"
                              v-for="(item, index) in despachos_casa.weekOne"
                              :key="index"
                              @click="
                                seleccionar_entrega(
                                  item.id_delivery,
                                  'Despacho a domicilio',
                                  selected_address_desc,
                                  item.delivery_cost,
                                  item.delivery_date,
                                  item.delivery_schedule,
                                )
                              "
                            >
                              <small>
                                {{ item.delivery_date | esDatewName }}
                              </small>
                            </th></template
                          >
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row"><small>09:00 a 19:00 hrs</small></th>

                          <td v-for="(item, index) in despachos_casa.weekOne" :key="index">
                            {{ item.delivery_cost == 0 ? 'GRATIS' : 'S/ ' + item.delivery_cost }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">-</th>

                          <td v-for="(item, index) in despachos_casa.weekOne" :key="index">
                            <a
                              href
                              data-dismiss="modal"
                              @click="
                                seleccionar_entrega(
                                  item.id_delivery,
                                  'Despacho a domicilio',
                                  selected_address_desc,
                                  item.delivery_cost,
                                  item.delivery_date,
                                  item.delivery_schedule,
                                )
                              "
                              ><small>Seleccionar</small></a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="lugar-hora-precio table-responsive">
                    <table class="table table-bordered">
                      <thead class="thead-gris">
                        <tr>
                          <th scope="col">
                            <small><strong>Horario</strong></small>
                          </th>
                          <th
                            scope="col"
                            v-for="(item, index) in despachos_casa.weekTwo"
                            :key="index"
                            @click="
                              seleccionar_entrega(
                                item.id_delivery,
                                'Despacho a domicilio',
                                selected_address_desc,
                                item.delivery_cost,
                                item.delivery_date,
                                item.delivery_schedule,
                              )
                            "
                          >
                            <small>
                              {{ item.delivery_date | esDatewName }}
                            </small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row"><small>09:00 a 19:00 hrs</small></th>

                          <td v-for="(item, index) in despachos_casa.weekTwo" :key="index">
                            {{ item.delivery_cost == 0 ? 'GRATIS' : 'S/ ' + item.delivery_cost }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">-</th>

                          <td v-for="(item, index) in despachos_casa.weekTwo" :key="index">
                            <a
                              href
                              data-dismiss="modal"
                              @click="
                                seleccionar_entrega(
                                  item.id_delivery,
                                  'Despacho a domicilio',
                                  selected_address_desc,
                                  item.delivery_cost,
                                  item.delivery_date,
                                  item.delivery_schedule,
                                )
                              "
                              ><small>Seleccionar</small></a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
                <template v-else>
                  <h3>Advertencia</h3>
                  <p>Debe seleccionar una dirección de despacho para continuar.</p>
                  <div class="text-center">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Cerrar</button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Despacho a Provincia -->
        <div
          class="modal fade"
          id="provincia"
          tabindex="-1"
          role="dialog"
          aria-labelledby="provincia"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-body text-center modal-contenido">
                <button type="button" class="btn-close-modern" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>

                <template v-if="paso_provincia == 1">
                  <h3>Aviso</h3>
                  <p>
                    Estimado Cliente, ha seleccionado una zona de despacho fuera de Lima Metropolitana
                    (LM), debe seleccionar la agencia de transporte en la que realizará el envío.
                  </p>
                  <p>¿Desea continuar con su compra?</p>
                  <div class="text-center">
                    <button type="button" class="btn btn-primary" @click="paso_provincia = 2">
                      Si
                    </button>
                    <button type="button" class="btn btn-primary" @click="paso_provincia = 4">
                      No
                    </button>
                  </div>
                </template>
                <template v-if="paso_provincia == 2">
                  <h3>Seleccione empresa de transporte</h3>
                  <br />
                  <div class="row sin-padding">
                    <div class="col-sm-12">
                      <form @submit="buscarAgencias()">
                        <div class="form-group">
                          <div class="row sin-padding">
                            <div class="col-sm-10">
                              <input
                                v-model="search_atributte"
                                class="form-control"
                                id="elementsAppendButton"
                                type="text"
                                placeholder="Ingrese el ruc o el nombre de agencia que desea buscar"
                                required
                                maxlength="60"
                              />
                            </div>
                            <div class="col-sm-2">
                              <button class="btn btn-primary" type="button" @click="buscarAgencias()">
                                Buscar
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="container">
                    <div id="accordion" class="acordeon" v-if="agency_address_list.length > 0">
                      <div
                        class="card card-guide"
                        v-for="(item, index) in agency_address_list"
                        :key="index"
                      >
                        <div class="card-header" :id="'heading' + index">
                          <button
                            :class="index == 0 ? 'btn btn-link' : 'btn btn-link collapsed'"
                            data-toggle="collapse"
                            :data-target="'#collapse' + index"
                            aria-expanded="true"
                            :aria-controls="'#collapse' + index"
                          >
                            <h5 class="mb-0">{{ item.transport_agency_name }}</h5>
                            <span class="material-icons">expand_less</span>
                          </button>
                        </div>

                        <div
                          :id="'collapse' + index"
                          :class="index == 0 ? 'collapse show' : 'collapse'"
                          :aria-labelledby="'#heading' + index"
                          data-parent="#accordion"
                        >
                          <div class="card-body">
                            <ul class="list-group">
                              <li
                                v-for="(item_direccion, index2) in item.address_list"
                                :key="index2"
                                class="list-group-item"
                                @click="irAlPaso3_transportes(item_direccion, item.ruc_agency)"
                                style="text-align: left;"
                              >
                                <span style="text-align: left;">{{
                                  ' Ubicación: LIMA, LIMA, ' +
                                    item_direccion.id_district.desc_district +
                                    ', ' +
                                    item_direccion.address +
                                    ' '
                                }}</span
                                ><a
                                  style="color: blue; text-align: right;"
                                  @click="irAlPaso3_transportes(item_direccion, item.ruc_agency)"
                                  >Seleccionar</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div style="float: left; padding-right: calc(0.5%);">
                        <small>Mostrando pagina {{ current_page }} de {{ final_page }}</small>
                      </div>
                      <!-- Paginado -->
                      <div style="float: right; padding-right: calc(0.5%);">
                        <nav>
                          <ul
                            role="menubar"
                            aria-disabled="false"
                            aria-label="Pagination"
                            class="pagination b-pagination pagination-sm"
                          >
                            <template v-if="current_page == 1">
                              <li role="none presentation" class="page-item disabled">
                                <a
                                  role="menuitem"
                                  tabindex="-1"
                                  aria-label="Goto next page"
                                  target="_self"
                                  class="page-link"
                                  ><span aria-hidden="true" class="page-selector">«</span></a
                                >
                              </li>
                            </template>
                            <template v-else>
                              <li
                                role="none presentation"
                                class="page-item"
                                @click="obtener_direcciones_agencias_paginado(1)"
                              >
                                <a
                                  role="menuitem"
                                  tabindex="-1"
                                  aria-label="Goto next page"
                                  target="_self"
                                  class="page-link"
                                  ><span aria-hidden="true" class="page-selector">«</span></a
                                >
                              </li>
                            </template>
                            <template v-if="current_page > 1">
                              <li
                                role="none presentation"
                                class="page-item"
                                aria-hidden="true"
                                @click="obtener_direcciones_agencias_paginado(current_page - 1)"
                              >
                                <span class="page-link page-selector">‹</span>
                              </li>
                            </template>
                            <template v-else>
                              <li
                                role="none presentation"
                                class="page-item disabled"
                                aria-hidden="true"
                              >
                                <span class="page-link page-selector">‹</span>
                              </li>
                            </template>
                            <li
                              v-for="page in pages"
                              :key="page"
                              role="none presentation"
                              :class="['page-item', page === current_page ? 'active' : '']"
                              @click="obtener_direcciones_agencias_paginado(page)"
                            >
                              <a
                                role="menuitemradio"
                                tabindex="-1"
                                aria-label="Goto page 2"
                                aria-checked="false"
                                aria-posinset="2"
                                aria-setsize="4"
                                target="_self"
                                class="page-link page-selector"
                                >{{ page }}</a
                              >
                            </li>
                            <template v-if="current_page == final_page">
                              <li role="none presentation" class="page-item disabled">
                                <a
                                  role="menuitem"
                                  tabindex="-1"
                                  aria-label="Goto next page"
                                  target="_self"
                                  class="page-link"
                                  ><span aria-hidden="true" class="page-selector">›</span></a
                                >
                              </li>
                            </template>
                            <template v-else>
                              <li
                                role="none presentation"
                                class="page-item"
                                @click="obtener_direcciones_agencias_paginado(current_page + 1)"
                              >
                                <a
                                  role="menuitem"
                                  tabindex="-1"
                                  aria-label="Goto next page"
                                  target="_self"
                                  class="page-link"
                                  ><span aria-hidden="true" class="page-selector">›</span></a
                                >
                              </li>
                            </template>
                            <template v-if="current_page == final_page">
                              <li role="none presentation" class="page-item disabled">
                                <a
                                  role="menuitem"
                                  tabindex="-1"
                                  aria-label="Goto next page"
                                  target="_self"
                                  class="page-link"
                                  ><span class="page-selector" aria-hidden="true">»</span></a
                                >
                              </li>
                            </template>
                            <template v-else>
                              <li
                                role="none presentation"
                                class="page-item"
                                @click="obtener_direcciones_agencias_paginado(final_page)"
                              >
                                <a
                                  role="menuitem"
                                  tabindex="-1"
                                  aria-label="Goto next page"
                                  target="_self"
                                  class="page-link"
                                  ><span class="page-selector" aria-hidden="true">»</span></a
                                >
                              </li>
                            </template>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="paso_provincia == 3">
                  <h3>Despacho en agencia de transporte</h3>
                  <p>Elija el día de su preferencia.</p>

                  <div class="lugar-hora-precio table-responsive">
                    <table class="table table-bordered">
                      <thead class="thead-gris">
                        <tr>
                          <th scope="col">
                            <small><strong>Horario</strong></small>
                          </th>
                          <th
                            scope="col"
                            v-for="(item, index) in despachos_casa.weekOne"
                            :key="index"
                            @click="
                              seleccionar_entrega_provincia(
                                item.id_delivery,
                                'Despacho a domicilio',
                                selected_address_desc,
                                item.delivery_cost,
                                item.delivery_date,
                              )
                            "
                          >
                            <small>
                              {{ item.delivery_date | esDatewName }}
                            </small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row"><small>09:00 a 19:00 hrs</small></th>

                          <td v-for="(item, index) in despachos_casa.weekOne" :key="index">
                            {{ item.delivery_cost == 0 ? 'GRATIS' : 'S/ ' + item.delivery_cost }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">-</th>

                          <td v-for="(item, index) in despachos_casa.weekOne" :key="index">
                            <a
                              href
                              data-dismiss="modal"
                              @click="
                                seleccionar_entrega_provincia(
                                  item.id_delivery,
                                  'Despacho a domicilio',
                                  selected_address_desc,
                                  item.delivery_cost,
                                  item.delivery_date,
                                )
                              "
                              ><small>Seleccionar</small></a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="lugar-hora-precio table-responsive">
                    <table class="table table-bordered">
                      <thead class="thead-gris">
                        <tr>
                          <th scope="col">
                            <small><strong>Horario</strong></small>
                          </th>
                          <th
                            scope="col"
                            v-for="(item, index) in despachos_casa.weekTwo"
                            :key="index"
                            @click="
                              seleccionar_entrega_provincia(
                                item.id_delivery,
                                'Despacho a domicilio',
                                selected_address_desc,
                                item.delivery_cost,
                                actual_date.getDate() + index,
                              )
                            "
                          >
                            <small>
                              {{ item.delivery_date | esDatewName }}
                            </small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row"><small>09:00 a 19:00 hrs</small></th>

                          <td v-for="(item, index) in despachos_casa.weekTwo" :key="index">
                            {{ item.delivery_cost == 0 ? 'GRATIS' : 'S/ ' + item.delivery_cost }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">-</th>

                          <td v-for="(item, index) in despachos_casa.weekTwo" :key="index">
                            <a
                              href
                              data-dismiss="modal"
                              @click="
                                seleccionar_entrega_provincia(
                                  item.id_delivery,
                                  'Despacho a domicilio',
                                  selected_address_desc,
                                  item.delivery_cost,
                                  actual_date.getDate() + index,
                                )
                              "
                              ><small>Seleccionar</small></a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
                <template v-if="paso_provincia == 4">
                  <h3>Advertencia</h3>
                  <p>
                    Estimado Cliente, para completar su compra puede comunicarse con: Blanca Aguilar
                    al 998365524 o escribir a baguilar@frutarom.com que gustosamente lo atenderá para
                    que complete su compra.
                  </p>
                  <div class="text-center">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">
                      Aceptar
                    </button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-md-8">
              <form @submit.prevent="updateAccount">
                <h2>
                  Tus Datos: <strong>{{ client_name + ' ' + client_lastname }}</strong>
                </h2>
                <div class="hrdivider"><hr /></div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="row" style="padding-bottom: 0px;">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-4 form-col">
                              <label for="firstName" class="control-label">Nombre *: </label>
                            </div>
                            <div class="col-sm-8">
                              <input
                                type="text"
                                id="firstName"
                                v-model="client_name"
                                placeholder="Nombre*"
                                maxlength="24"
                                minlength="2"
                                required="required"
                                class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-4 form-col">
                              <label for="lastName" class="control-label">Apellido *: </label>
                            </div>
                            <div class="col-sm-8">
                              <input
                                type="text"
                                id="lastName"
                                v-model="client_lastname"
                                placeholder="Apellido*"
                                maxlength="24"
                                minlength="2"
                                required="required"
                                class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-4 form-col">
                              <label for="lastName" class="control-label">DNI *: </label>
                            </div>
                            <div class="col-sm-8">
                              <input
                                type="text"
                                v-model="client_dni"
                                required="required"
                                id="dni"
                                placeholder="DNI"
                                maxlength="8"
                                pattern="[0-9]{8}"
                                title="Sólo se permiten números. Debe ingresar un DNI válido."
                                class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-4 form-col">
                              <label for="lastName" class="control-label">Teléfono *: </label>
                            </div>
                            <div class="col-sm-8">
                              <input
                                type="text"
                                v-model="cliente_phone"
                                id="phone"
                                placeholder="Teléfono"
                                maxlength="11"
                                pattern="[0-9]{7,11}"
                                title="Sólo se permiten números. Debe ingresar un teléfono válido."
                                required="required"
                                class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <button type="submit" class="btn btn-primary btn-actualizar">
                          Actualizar mis datos
                        </button>
                      </div>
                      <div class="col" style="padding-top:10px;">
                        <div
                          :class="[mensaje === '' ? 'd-none' : 'alert alert-success']"
                          role="alert"
                        >
                          <button type="button" class="close" data-dismiss="alert">&times;</button
                          ><strong>{{ mensaje }}</strong>
                        </div>
                        <div
                          :class="[mensaje_error === '' ? 'd-none' : 'alert alert-danger']"
                          role="alert"
                        >
                          <button type="button" class="close" data-dismiss="alert">&times;</button
                          ><strong>{{ mensaje_error }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Bloque para Agregar y Modificar direcciones -->
                  <div class="col-12">
                    <div class="hrdivider"><hr /></div>
                    <div class="direcciones-header">
                      <h2>Elija una dirección de despacho</h2>
                      <button
                        data-toggle="modal"
                        data-target="#nuevadireccion"
                        class="btn btn-primary"
                        @click="resetform_agregar_direccion()"
                      >
                        <i class="fa fa-plus"></i> Crear nueva dirección
                      </button>
                    </div>
                    <div class="direcciones-items">
                      <div class="funkyradio">
                        <div
                          v-for="(address, index) in address_list"
                          :key="address.id_address"
                          class="funkyradio-primary"
                        >
                          <input
                            type="radio"
                            name="direccion"
                            :id="'direccion' + index"
                            @click="select_address(address)"
                          />
                          <label :for="'direccion' + index"
                            ><span>{{
                              address.id_district.desc_district + ', ' + address.address
                            }}</span>
                            <button
                              class="btn btn-primary"
                              data-toggle="modal"
                              data-target="#modificardireccion"
                              @click="detalle_direccion(address)"
                            >
                              <i class="fa fa-pencil"></i><span>Modificar</span>
                            </button>
                            <template v-if="address_list.length > 1">
                              <button
                                class="btn btn-danger"
                                @click="eliminar_direccion(address.id_address)"
                              >
                                <i class="fa fa-trash"></i><span>Eliminar</span>
                              </button>
                            </template>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- FIN de Bloque para Agregar y Modificar direcciones -->
                </div>
              </form>
            </div>
            <div class="card col-sm-12 col-md-4" style="height: auto;">
              <br />
              <h5><strong>Seleccione su Método de Entrega</strong></h5>
              <br />
              <div class="row">
                <template v-if="selected_address != '' && only_lima == false">
                  <div class="col-sm-12">
                    <button
                      data-toggle="modal"
                      data-target="#provincia"
                      class="btn btn-al btn-al-lg btn-light button-iff"
                      style="width: 100%;"
                      @click="paso_provincia = 1"
                    >
                      <i class="fa fa-truck"></i><br /><small>Despacho A Domicilio</small>
                    </button>
                  </div>
                </template>
                <template v-else>
                  <div class="col-sm-12">
                    <button
                      data-toggle="modal"
                      data-target="#domicilio"
                      class="btn btn-al btn-al-lg btn-light button-iff"
                      style="width: 100%;"
                      @click="obtener_despachos_acasa()"
                    >
                      <i class="fa fa-truck"></i><br /><small>Despacho A Domicilio</small>
                    </button>
                  </div>
                </template>
              </div>
              <br />
              <div class="row">
                <div class="col-sm-12">
                  <button
                    data-toggle="modal"
                    data-target="#retiro"
                    class="btn btn-al btn-al-lg btn-light button-iff"
                    style="width: 100%;"
                    @click="obtener_despachos_recojo()"
                  >
                    <i class="fa fa-shopping-bag"></i><br /><small>Retiro en tienda</small>
                  </button>
                </div>
                <!---->
                <div class="col-sm-12" v-if="seleccion_entrega">
                  <br />
                  <strong>DETALLES DE ENTREGA:</strong>
                  <p style="text-align: left;">
                    <small
                      ><strong>Tipo de entrega:</strong> {{ tipo_entrega }}<br />
                      <template v-if="direccion_agencia_transporte_desc != ''">
                        <strong>Dirección de destino: </strong>
                      </template>
                      <template v-else>
                        <strong>Lugar de Entrega: </strong>
                      </template>
                      <span v-html="lugar_entrega"></span>
                      <template v-if="direccion_agencia_transporte_desc != ''">
                        <br />
                        <strong>Lugar de entrega (Agencia de Transporte): </strong>
                        <span v-html="direccion_agencia_transporte_desc"></span>
                      </template>
                      <br />
                      <strong>Fecha de despacho:</strong> {{ dia_entrega | esDate }}
                      <br />
                      <strong>Costo de entrega:</strong> {{ costo_entrega | currency }}</small
                    >
                  </p>
                  <template v-if="direccion_agencia_transporte_desc != ''">
                    <br />
                    <small
                      >IFF Perú garantiza el despacho hasta la agencia de transporte. La entrega de su
                      pedido desde la agencia de transporte hasta su dirección de destino es
                      responsabilidad del cliente.</small
                    >
                  </template>
                </div>
              </div>
              <div class="row text-center">
                <div class="container">
                  <template v-if="seleccion_entrega">
                    <router-link
                      :to="'/resumen'"
                      class="btn btn-primary mt-2 text-white"
                      style="width: 100%;"
                      >Pagar Productos</router-link
                    >
                  </template>
                  <template v-else>
                    <a class="btn btn-primary mt-2 text-white disabled" style="width: 100%;"
                      >Pagar Productos</a
                    >
                  </template>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
        </div>
      </section>
      <TwoModules></TwoModules>
      <News></News>
    </div>
  </div>
</template>

<script>
import TwoModules from '@/components/products/TwoModules.vue';
import News from '@/components/products/Guia.vue';
import Vue from 'vue';
import toastr from 'toastr';
import { mapState, mapActions, mapMutations } from 'vuex';
import axios from 'axios';
import { successToaster, errorToaster } from '../../../shared/service/ErrorHandler.js';
import { config_settings } from '../../../../config.js';
import DraggableCal from 'vue-draggable-cal';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const CONFLICT = 409;
const INTERNAL_SERVER_ERROR = 500;

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.message === 'Network Error') {
      toastr.error(
        'No se puede conectar con el servidor. Verifique su conexión a internet',
        'ERROR',
        { iconClass: 'customer-danger' },
      );
    } else if (error.response.status === UNAUTHORIZED) {
      if (error.response.data.message === 'Access is denied') {
        toastr.error('Usted no tiene los provilegios para acceder a esta sección', 'ERROR', {
          iconClass: 'customer-danger',
        });
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default {
  name: 'CreateAccount',
  created() {
    this.scroll_inicio();
    this.get_puser_data();
    this.callDepartamentos();
    this.obtener_direcciones();
    this.obtener_direcciones_agencias();
    this.analizeCart();
  },
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      url_image_preview: config_settings.PHOTO_SERVER_URL + '/clients/empty-img.jpg',
      mensaje: '',
      mensaje_error: '',
      showLoader: false,
      client_email: '',
      client_username: '',
      client_password: '',
      client_name: '',
      client_lastname: '',
      client_dni: '',
      cliente_phone: '',
      cboDepartamento: '',
      cboProvincia: '',
      cboDistrito: '',
      client_address: '',
      depas_array: [],
      province_array: [],
      distrito_array: [],
      token: localStorage.getItem('access_token'),
      refresh_token: localStorage.getItem('refresh_token'),
      actual_date: new Date(),
      address_list: [],
      agency_address_list: [],
      cboDepartamento_modal: '',
      cboProvincia_modal: '',
      cboDistrito_modal: '',
      client_address_modal: '',
      id_address_modal: '',
      isdisabled: true,
      isdisabled_distrito: true,
      isdisabled_direccion: true,
      selected_address: '',
      selected_address_desc: '',
      selected_address_district: '',
      despachos_recojo: [],
      despachos_casa: '',
      updateClientData: false,
      tipo_entrega: '',
      lugar_entrega: '',
      prefix_lugar_entrega: '',
      costo_entrega: '',
      dia_entrega: '',
      seleccion_entrega: false,
      only_lima: false,
      paso_provincia: 1,
      selected_transport_address: '',
      direccion_agencia_transporte_desc: '',
      totalValue: 0.0,
      search_atributte: '',
      horario: '',
      pages: [],
      current_page: 1,
      final_page: 1,
      crit: 5, //number of products per page
      loadingUbigeo: false,
    };
  },
  components: { TwoModules, DraggableCal, News },
  computed: mapState(['cartProducts']),
  methods: {
    analizeCart() {
      let actual_total = 0;

      this.cartProducts.forEach((product, index) => {
        var subtotal = (product.price_product / 1.18) * (product.qty * 1.18) * 100;
        subtotal = Math.round(subtotal) / 100.0;
        actual_total = actual_total + subtotal;
      });
      this.totalValue = actual_total;
    },

    seleccionar_entrega(id_entrega, tipo_entrega, lugar_entrega, costo, dia, horario) {
      console.log('ESTE ES EL DIASS: ' + dia);
      if (this.loadingUbigeo && tipo_entrega !== 'Retiro en tienda') {
        toastr.warning('Obteniendo detalles de ubicación, por favor espere...');
        return;
      }

      if (!this.prefix_lugar_entrega && tipo_entrega !== 'Retiro en tienda') {
        toastr.error(
          'No se pudo determinar la ubicación exacta. Intente seleccionar la dirección nuevamente.',
        );
        return;
      }

      this.direccion_agencia_transporte_desc = '';
      this.tipo_entrega = tipo_entrega;
      this.horario = horario;
      if (this.tipo_entrega == 'Retiro en tienda') {
        this.lugar_entrega = lugar_entrega;
      } else {
        this.lugar_entrega = this.prefix_lugar_entrega + ', ' + lugar_entrega;
      }

      this.costo_entrega = costo;
      this.dia_entrega = dia;
      this.seleccion_entrega = true;
      var json_despacho = {
        id_delivery: id_entrega,
        day_delivery: dia,
        price_delivery: costo,
      };

      console.log('json de despacho ' + JSON.stringify(json_despacho));
      localStorage.setItem('id_delivery', id_entrega);
      localStorage.setItem('day_delivery', dia);
      localStorage.setItem('price_delivery', costo);
      localStorage.setItem('dir_agency', '');
      localStorage.setItem('ruc_agency', '');
    },

    seleccionar_entrega_provincia(id_entrega, tipo_entrega, lugar_entrega, costo, dia) {
      console.log('ESTE ES EL DIA DDD: ' + dia);
      var direccion_embarque = JSON.parse(localStorage.getItem('transport_address_details'));
      var ruc_transporte = JSON.parse(localStorage.getItem('transport_ruc'));
      var string_direccion = direccion_embarque.erp_code;
      this.tipo_entrega = tipo_entrega;
      this.lugar_entrega = this.prefix_lugar_entrega + ', ' + lugar_entrega;
      this.costo_entrega = costo;
      this.dia_entrega = dia;
      this.direccion_agencia_transporte_desc =
        'LIMA, LIMA, ' +
        direccion_embarque.id_district.desc_district +
        ', ' +
        direccion_embarque.address;
      this.seleccion_entrega = true;
      var json_despacho = {
        id_delivery: id_entrega,
        day_delivery: dia,
        price_delivery: costo,
        dir_agency: string_direccion,
        ruc_agency: ruc_transporte,
      };

      console.log('json de despacho ' + JSON.stringify(json_despacho));
      localStorage.setItem('id_delivery', id_entrega);
      localStorage.setItem('day_delivery', dia);
      localStorage.setItem('price_delivery', costo);
      localStorage.setItem('dir_agency', string_direccion);
      localStorage.setItem('ruc_agency', ruc_transporte);
    },

    select_address(address) {
      console.log('ESTE ES LA DIRECCION SELECIONADA: ' + JSON.stringify(address));
      this.selected_address = address.id_address;
      this.selected_address_desc = address.address;
      this.selected_address_district = address.id_district.id_district;
      this.callStringUbigeo(address.id_district.id_district);
      var json_address = address;
      localStorage.setItem('address_details', JSON.stringify(json_address));
    },

    irAlPaso3_transportes(item_direccion, ruc) {
      this.paso_provincia = 3;
      console.log(
        'ESTE ES LA DIRECCION SELECIONADA TRANSPORTE GA: ' + JSON.stringify(item_direccion),
      );
      var json_address = item_direccion;
      localStorage.setItem('transport_address_details', JSON.stringify(json_address));
      localStorage.setItem('transport_ruc', ruc);
      this.obtener_despachos_hacia_agencia(item_direccion.id_district.id_district);
    },

    scroll_inicio() {
      window.scrollTo(0, 0);
    },

    refreshToken() {
      var refresh_token = localStorage.getItem('refresh_token');
      var refresh_credentials = new FormData();
      refresh_credentials.append('grant_type', 'refresh_token');
      refresh_credentials.append('refresh_token', refresh_token);
      refresh_credentials.append('id_store', config_settings.STORE);

      const refreshingCall = axios({
        method: 'post',
        url: config_settings.AUTH_SERVER_URL + '/oauth/token',
        data: refresh_credentials,
        withCredentials: true,
        auth: {
          username: 'USER_CLIENT_APP',
          password: 'password',
        },
      }).then((response) => {
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    get_puser_data() {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/profile',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.url_image_preview =
            config_settings.PHOTO_SERVER_URL + '/' + response.data.photo_client + '.jpg';
          this.client_email = response.data.email_client;
          this.client_username = response.data.nick_client;
          this.client_name = response.data.name_client;
          this.client_lastname = response.data.surname_client;
          this.client_dni = response.data.dni_client;
          this.cliente_phone = response.data.phone_client;
          this.client_address = response.data.address_client;
          this.callDepartamentos();
          var cboDistrito = response.data.id_district.id_district;
          if (cboDistrito != 0) {
            this.cboDistrito = response.data.id_district.id_district;
            this.callUbigeo(this.cboDistrito);
          } else {
            this.cboDistrito = '';
          }
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.get_puser_data();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión para realizar su compra', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión para realizar su compra';
                this.mensaje = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    callUbigeo(cboDistrito) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/locations/' + cboDistrito,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.cboDepartamento_modal = response.data.departament.id_departament;

          this.callProvincias(response.data.departament.id_departament, true);
          this.cboProvincia_modal = response.data.province.id_province;
          this.callDistritos(response.data.province.id_province, true);
          this.isdisabled_direccion = false;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.callUbigeo(cboDistrito);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    async callStringUbigeo(cboDistrito) {
      // 1. Activamos el estado de carga y limpiamos el prefijo actual para evitar datos antiguos
      this.loadingUbigeo = true;
      this.prefix_lugar_entrega = '';

      try {
        // 2. Realizamos la petición asíncrona al servidor de recursos
        let response = await axios({
          method: 'get',
          url: config_settings.RESOURCE_SERVER_URL + '/GET/locations/' + cboDistrito,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
          },
        });

        // 3. Verificamos si la provincia corresponde a Lima (ID 127) para reglas de negocio
        if (response.data.province.id_province == 127) {
          console.log('LIMAAA');
          this.only_lima = true;
        } else {
          this.only_lima = false;
        }

        console.log('Es Lima: ' + this.only_lima);

        // 4. Construimos la cadena completa del lugar de entrega (Departamento, Provincia, Distrito)
        var respuesta =
          response.data.departament.desc_departament +
          ', ' +
          response.data.province.desc_province +
          ', ' +
          response.data.district.desc_district +
          ', ';

        console.log('ESTA ES LA RESPUESTA: ' + respuesta);

        // 5. Asignamos el resultado final a la variable global
        this.prefix_lugar_entrega = respuesta;
      } catch (error) {
        // 6. Gestión de errores en caso de fallo de red o servidor
        console.error('Error al obtener el Ubigeo:', error);
        this.prefix_lugar_entrega = ''; // Nos aseguramos de que quede vacío si falló la API

        // Opcional: Mostrar una alerta al usuario
        if (typeof toastr !== 'undefined') {
          toastr.error(
            'No se pudo cargar la ubicación. Por favor, intente seleccionar su dirección nuevamente.',
          );
        }
      } finally {
        // 7. Finalizamos el estado de carga independientemente de si hubo éxito o error
        this.loadingUbigeo = false;
      }
    },

    callDepartamentos() {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/locations/departments',
      })
        .then((response) => {
          this.depas_array = response.data;
        })
        .catch((error) => {
          console.log('Error al leer departamentos');
        });
    },

    callProvincias(cboDepartamento, component_start) {
      axios({
        method: 'get',
        url:
          config_settings.RESOURCE_SERVER_URL +
          '/GET/locations/departaments/' +
          cboDepartamento +
          '/provinces',
      })
        .then((response) => {
          this.province_array = response.data;
          if (component_start == false) {
            this.cboProvincia_modal = '';
            this.cboDistrito_modal = '';
            this.isdisabled_distrito = true;
            this.client_address_modal = '';
            this.isdisabled_direccion = true;
          }
          this.isdisabled = false;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.callProvincias(cboDepartamento, component_start);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    callDistritos(cboProvincia, component_start) {
      axios({
        method: 'get',
        url:
          config_settings.RESOURCE_SERVER_URL +
          '/GET/locations/departments/provinces/' +
          cboProvincia +
          '/districts',
      })
        .then((response) => {
          this.distrito_array = response.data;
          if (component_start == false) {
            this.cboDistrito_modal = '';
          }
          this.isdisabled_distrito = false;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.callDistritos(cboProvincia, component_start);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    enableDireccion() {
      this.isdisabled_direccion = false;
    },

    obtener_direcciones() {
      axios({
        method: 'GET',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/clients-address',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.address_list = response.data.clientaddress;
          console.log('LISTA DE DIRECCIONES' + JSON.stringify(this.address_list));
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.obtener_direcciones();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });

            console.log('ERROR FATAL :v');
          }
        });
    },

    resetform_agregar_direccion() {
      this.cboDepartamento_modal = '';
      this.cboProvincia_modal = '';
      this.cboDistrito_modal = '';
      this.client_address_modal = '';
      this.id_address_modal = '';
    },

    agregar_direccion() {
      var json_data = {
        id_district: { id_district: this.cboDistrito_modal },
        address: this.client_address_modal,
        state: { id_state: 1 },
      };

      axios({
        method: 'POST',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/clients-address',
        data: json_data,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.obtener_direcciones();
          this.resetform_agregar_direccion();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.agregar_direccion();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });

            console.log('ERROR FATAL :v');
          }
        });
    },

    eliminar_direccion(id_address) {
      axios({
        method: 'DELETE',
        url: config_settings.RESOURCE_SERVER_URL + '/DELETE/clients-address/' + id_address,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.obtener_direcciones();
          this.resetform_agregar_direccion();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.eliminar_direccion(id_address);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });

            console.log('ERROR FATAL :v');
          }
        });
    },

    detalle_direccion(address) {
      this.cboDistrito_modal = address.id_district.id_district;
      this.client_address_modal = address.address;
      this.id_address_modal = address.id_address;
      this.callUbigeo(address.id_district.id_district);
    },

    modificar_direccion() {
      var json_data = {
        id_address: this.id_address_modal,
        id_district: { id_district: this.cboDistrito_modal },
        address: this.client_address_modal,
      };

      axios({
        method: 'PUT',
        url: config_settings.RESOURCE_SERVER_URL + '/PUT/clients-address',
        data: json_data,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.obtener_direcciones();
          this.resetform_agregar_direccion();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.modificar_direccion();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });

            console.log('ERROR FATAL :v');
          }
        });
    },

    updateAccount() {
      this.updateClientData = false;

      this.showLoader = true;
      var distrito_json = '';
      var direccion_json = ' ';
      var dni_json = ' ';
      var phone_json = ' ';

      this.cboDistrito != ''
        ? (distrito_json = { id_district: this.cboDistrito })
        : (distrito_json = { id_district: null });
      this.client_address != '' ? (direccion_json = this.client_address) : (direccion_json = ' ');
      this.client_dni != '' ? (dni_json = this.client_dni) : (dni_json = null);
      this.cliente_phone != '' ? (phone_json = this.cliente_phone) : (phone_json = null);

      var json_data = {
        nick_client: this.client_username,
        dni_client: dni_json,
        name_client: this.client_name,
        surname_client: this.client_lastname,
        address_client: direccion_json,
        email_client: this.client_email,
        phone_client: phone_json,
        id_district: distrito_json,
        state: {
          id_state: 1,
        },
      };

      axios({
        method: 'put',
        url: config_settings.RESOURCE_SERVER_URL + '/PUT/profile-sale',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
        data: json_data,
      })
        .then((response) => {
          this.mensaje = 'Sus datos se actualizaron correctamente';
          this.mensaje_error = '';
          this.updateClientData = true;
        })
        .catch((error) => {
          if (error.response.status === CONFLICT) {
            this.mensaje_error =
              'El nombre de usuario o el e-mail que desea registrar ya existe en la base de datos.';
          } else if (error.response.status === BAD_REQUEST) {
            this.mensaje_error = 'Ingrese correctamente los datos solicitados.';
          } else {
            this.mensaje_error = 'Se ha producido un error. Inténtelo nuevamente.';
          }
          this.mensaje = '';
        });

      this.showLoader = false;
    },

    obtener_despachos_recojo() {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/deliverys/atstore')
        .then((response) => {
          this.despachos_recojo = response.data;
          console.log('Despachos a recojer ' + JSON.stringify(this.despachos_recojo));
        })
        .catch((error) => {
          //console.log(error)
        });
    },

    obtener_despachos_acasa() {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/deliverys/inhouse/district/' +
            this.selected_address_district +
            '/ammount/' +
            this.totalValue,
        )
        .then((response) => {
          this.despachos_casa = response.data;
          console.log('Despachos a casa ' + JSON.stringify(this.despachos_casa));
        })
        .catch((error) => {
          //console.log(error)
        });
    },

    obtener_despachos_hacia_agencia(id_district) {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/deliverys/inhouse/district/' +
            id_district +
            '/ammount/' +
            this.totalValue,
        )
        .then((response) => {
          this.despachos_casa = response.data;
          console.log('Despachos a casa ' + JSON.stringify(this.despachos_casa));
        })
        .catch((error) => {
          //console.log(error)
        });
    },

    obtener_direcciones_agencias() {
      axios({
        method: 'GET',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/transport-agency-address',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.agency_address_list = response.data.transport_agency_address;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = 1;
          console.log('LISTA DE DIRECCIONES AGENCIAS' + JSON.stringify(this.agency_address_list));
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.obtener_direcciones();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });

            console.log('ERROR FATAL :v');
          }
        });
    },

    obtener_direcciones_agencias_paginado(page) {
      axios({
        method: 'GET',
        url:
          config_settings.RESOURCE_SERVER_URL +
          '/GET/transport-agency-address?xPag=' +
          this.crit +
          '&&nPag=' +
          page +
          '',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.agency_address_list = response.data.transport_agency_address;
          console.log('LISTA DE DIRECCIONES AGENCIAS' + JSON.stringify(this.agency_address_list));
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = page;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.obtener_direcciones_agencias_paginado(page);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });

            console.log('ERROR FATAL :v');
          }
        });
    },

    buscarAgencias() {
      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/search-transport-agency-address',
        data: {
          query: this.search_atributte,
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.agency_address_list = response.data.transport_agency_address;
          console.log('LISTA DE DIRECCIONES AGENCIAS' + JSON.stringify(this.agency_address_list));
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.buscarAgencias();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });

            console.log('ERROR FATAL :v');
          }
        });
    },
  },
};
</script>

<style lang="scss" src="./CartProducts-3.scss"></style>
